import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import PostList from "../list/PostList";
import Nav from "../list/Nav";
import data from "../../data.json";
import skill_writing from "../../skill.json";
import importImage from '../list/ImportImage'
import BusinessInfo from "../list/BusinessInfo";
import About from "../list/About";
import Footer from "../list/Footer";
import Text from "../list/Text";

const Container = styled.div`
    & > * {
        margin-bottom: 2%;
    }
       align-items: center; 
  justify-content: center;
 
`;

 

const ImageBody = styled.div`
  background-image: url(${props => props.image});
  padding: 10%;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 120%;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 1;
  }

  @media (max-width: 965px) {
    background-position: 30% center;
  }
`;

const ColorBody = styled.div`
  background-color: white;
  width: 100vw;
  position: relative;
   
`;

const RowWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const PageWrapper = styled.div`
  overflow: hidden;
`;

function MainPage() {
  const navigate = useNavigate();

  return (
    <PageWrapper>
    <ImageBody image="/bg.webp">
        
          <Nav />
          <Text />
       </ImageBody>
     
          
            <RowWrapper>
         

                <Wrapper>

                    <Container>
              
                        <About/>
                        <ColorBody> 
                        <PostList
                            posts={data}
                            onClick={(item) => {
                                navigate(`/post/${item.id}`);
                            }}
                        />
                        </ColorBody>
                        
                    </Container>
                 <BusinessInfo /> 
                </Wrapper>

    
            
            </RowWrapper>

            <RowWrapper>
            <Footer />
            </RowWrapper>
            
        </PageWrapper>
    );
}

export default MainPage;
